import { ReactElement, useState } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import { siteName } from '~/constants/siteConfig';
import HeroHexagon from './HeroHexagon';
import classnames from 'classnames';
import Link from '@Hotels-at-Home/hah-fe-core/dist/components/Link';

const HeroSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });

  const [active, setActive] = useState(false);

  return (
    <section className="base-section hero-section hero-wrap" id="HP_hero_bed">
      <div className="desktop-viewport">
        <Link href={tLink('coverletAndShams')}>
          <div className="hero-copy-wrap">
            <div className="stack">
              <h1>
                <Trans i18nKey="title" t={t} components={{ span: <span /> }} />
              </h1>
              <p className="sub-copy">{t('description')}</p>
              <Button ariaLabel={t('texturedCoverlet')}>{tButton('shopNow')}</Button>
            </div>
          </div>
          <div className={classnames('main-hp', { active })} id="hero">
            <div className="detail" />
            <div
              className="elements"
              onClick={e => {
                e.preventDefault();
                setActive(!active);
              }}
              role="button"
              tabIndex={0}
              aria-label="elements"
              onKeyUp={() => {}}
            />
            <div className="more-info">
              <div className="stack">
                <h2>
                  <Trans i18nKey="moreInfo" t={t} components={{ span: <span /> }} />
                </h2>
                <picture>
                  <source srcSet="/images/homePage/fill.gif" media="(max-width: 801px)" />
                  <img
                    src="/images/homePage/heroSection/courtyard-linens-detail.png"
                    alt={tCategory('linens')}
                    width={300}
                    height={142}
                    loading="lazy"
                    decoding="async"
                    fetchPriority="low"
                  />
                </picture>
                <div className="hexagon-list">
                  <HeroHexagon iconClass="versatile" text={t('versatile')} />
                  <HeroHexagon iconClass="light" text={t('light')} />
                  <HeroHexagon iconClass="easywashing" text={t('easyWashing')} />
                </div>
              </div>
            </div>
            <div className="hero-image">
              <picture>
                <source
                  srcSet="/images/homePage/heroSection/courtyard-hero-bed-mob.webp"
                  media="(max-width: 801px)"
                />
                <img
                  src="/images/homePage/heroSection/courtyard-hero-bed.webp"
                  alt={t('texturedCoverlet')}
                  width="1920"
                  height="1080"
                  loading="eager"
                  fetchPriority="high"
                />
              </picture>
            </div>
          </div>
        </Link>
      </div>
      <div className="hp-mobile-viewport main-hp">
        <a
          className="mob-section-link"
          href={tLink('coverletAndShams')}
          id="HP_hero_bed-mob"
          aria-label={t('texturedCoverlet')}
        >
          <div className="hexagon-list">
            <HeroHexagon iconClass="versatile" text={t('versatile')} />
            <HeroHexagon iconClass="light" text={t('light')} />
            <HeroHexagon iconClass="easywashing" text={t('easyWashing')} />
          </div>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
